/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { CurrencyValueModel } from './currency-value.model';
import { TimeAvailabilityModel } from './time-availability.model';
import { HandoverOfferDtoModel } from './handover-offer-dto.model';
import { VehicleVoModel } from '@well/delivery-libs/vehicle-management/domain';
import { DriverVoModel } from '@well/delivery-libs/driver-management/domain';

export class RoutingSolutionDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  routeUuid?: string;
  routeTemplateUuid?: string;
  shipmentGroupUuid?: string;
  vendorOfferUuid?: string;
  cost: CurrencyValueModel | undefined = undefined;
  details?: string;
  label?: string;
  vehicleTypeValue?: string;
  licensePlate?: string;
  driverName?: string;
  driverVO?: DriverVoModel;
  vehicleVO?: VehicleVoModel;
  timeAvailability: TimeAvailabilityModel | undefined = undefined;
  handoverOfferDtos: HandoverOfferDtoModel[] | undefined = undefined;
  paymentTimeLimit: string | undefined = undefined;
  vendorPrice: CurrencyValueModel | undefined = undefined;
  vendorOrderUuid: string | undefined = undefined;

  // frontend only
  createdBy?: string;
}
